import { UploadFile } from "antd";
import { GuideFile } from "../interfaces/guides.interface";
import { Pagination } from "../interfaces/pagination.interface";
import http from "./axios";
import {
  addFilesToBody,
  convertObjectToFormData,
  handleError,
} from "./http-utils.service";
import { downloadFile } from "./http-utils.service";

export const getAllGuides = async (props: Pagination) => {
  const { limit, skip, query } = props;
  const options = {
    params: {
      limit,
      skip,
      ...(query ? { query } : {}),
    },
  };
  try {
    const response = await http.get<{
      count: number;
      list: GuideFile[];
    }>(`/guides`, options);
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const downloadGuideFile = async (id: number, name: string) => {
  if (name === "") return false;

  try {
    const response = await http.get<{ url: string }>(`/guides/${id}/download`, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });
    const res = await http.get<Blob>(response.data.url, {
      responseType: "blob",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });

    downloadFile(res.data, name);
    return res.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const deleteGuide = async (id: number) => {
  try {
    const response = await http.delete(`/guides/${id}`);
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const createGuide = async (
  info: { description: string },
  files: UploadFile[],
) => {
  const formData = convertObjectToFormData(info);
  addFilesToBody(formData, files);
  try {
    const response = await http.post(`guides`, formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    if (response.data) {
      return response.data;
    } else {
      throw new Error("Error al subir los archivos");
    }
  } catch (error) {
    files[0].status = "error";
    return files;
  }
};
